interface Array<T> {
    move(oldIndex: number, newIndex: number): Array<T>
    indexOfObject(propertyName, value): number
    injectArray(idx: number, arr: Array<T>): Array<T>

    firstOrDefault(): T
    firstOrDefault(predicate: (item: T) => boolean): T

    sortByProperty(GetProperty: (value: T) => any): Array<T>
    sortByPropertyDesc(GetProperty: (value: T) => any): Array<T>

    filterSearch(searchText: string, GetProperty: (Item: T) => string): Array<T>
    filterSearchAdvanced(searchText: string, EvaluationFunction: (BaseEvalFct: (value: string) => boolean, Item: T) => boolean): Array<T>

    distinct(): Array<T>

    groupBy(getGroupKey: (item) => string): Array<Array<T>>
    groupByDictionary(getGroupKey: (item) => string): { [key: string]: Array<T> }

    max(): number;
    min(): number;

    contains(item): boolean;

    any(): boolean;

    isEmpty(): boolean;
}

Array.prototype.any = function() {
    return this.length > 0;
}

Array.prototype.isEmpty = function() {
    return this.length === 0;
}

Array.prototype.contains = function (item) {
    const myArray: Array<any> = this;
    return myArray.some(x => x === item);
};


Array.prototype.max = function () {
    return Math.max.apply(null, this);
};

Array.prototype.min = function () {
    return Math.min.apply(null, this);
};

Array.prototype.groupBy = function (getGroupKey: (item) => string) {
    const myArray: Array<any> = this;
    const groups = {};
    myArray.forEach(o => {
        const group = getGroupKey(o);
        groups[group] = groups[group] || [];
        groups[group].push(o);
    });

    return Object.keys(groups).map(group => {
        return groups[group];
    })
}

Array.prototype.groupByDictionary = function (getGroupKey: (item) => string) {
    const myArray: Array<any> = this;
    const groups: { [key: string]: Array<any> } = {};
    myArray.forEach(o => {
        const group = getGroupKey(o);
        groups[group] = groups[group] || [];
        groups[group].push(o);
    });

    return groups;
}

Array.prototype.firstOrDefault = function (predicate: (item) => boolean = null) {
    const myArray: Array<any> = this;
    if (myArray == null || myArray.length === 0) {
        return null;
    }
    else if (predicate != null) {
        return myArray.filter(predicate).firstOrDefault();
 }
    else {
        return myArray[0];
 }
}

Array.prototype.filterSearch = function (searchText: string, GetProperty: (Item: any) => string) {
    return this.filterSearchAdvanced(searchText, (BaseEvalFct, item) => BaseEvalFct(GetProperty(item)));
}

Array.prototype.distinct = function () {
    return this.filter((x, i, a) => a.indexOf(x) === i);
}

Array.prototype.sortByProperty = function (getvalue: (value: any) => any) {
    const myArray: Array<any> = this;
    myArray.sort((a: any, b: any) => {
        const valueA = getvalue(a);
        const valueB = getvalue(b);
        if (typeof (valueA) === "string" && typeof (valueB) === "string") {
            return valueA.toLocaleUpperCase().localeCompare(valueB.toLocaleUpperCase(), "en", {sensitivity: "base"});
        } else if (typeof (valueA) === "number" && typeof (valueB) === "number") {
            return valueA - valueB;
        } else {
            return valueA >= valueB ? 1 : -1;
        }
    });
    return myArray;
};


Array.prototype.sortByPropertyDesc = function (getvalue: (value: any) => any) {
    const myArray: Array<any> = this;
    myArray.sort((a: any, b: any) => {
        const valueA = getvalue(a);
        const valueB = getvalue(b);
        if (typeof (valueA) === "string" && typeof (valueA) === "string") {
            return valueB.toLocaleUpperCase().localeCompare(valueA.toLocaleUpperCase(), "en", {sensitivity: "base"});
        } else if (typeof (valueA) === "number" && typeof (valueB) === "number") {
            return valueB - valueA;
        } else {
            return valueA < valueB ? 1 : -1;
        }
    });
    return myArray;
};

Array.prototype.injectArray = function (idx, arr) {
    return this.slice(0, idx).concat(arr).concat(this.slice(idx));
};


Array.prototype.move = function (oldIndex, newIndex) {
    if (newIndex >= this.length) {
        let k = newIndex - this.length;
        while ((k--) + 1) {
            this.push(undefined);
        }
    }
    this.splice(newIndex, 0, this.splice(oldIndex, 1)[0]);
    return this; // for testing purposes
};

Array.prototype.indexOfObject = function arrayObjectIndexOf(property, value) {
    for (let i = 0, len = this.length; i < len; i++) {
        if (this[i][property] === value) { return i; }
    }
    return -1;
}



// WEBPACK FOOTER //
// ./src/utilities/ArrayExtensions.ts